var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIcSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 12 13"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#ic-search_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "m11.855 11.645-2.44-2.48A5.36 5.36 0 0 0 10.57 5.84C10.565 2.89 8.2.5 5.285.5S0 2.89 0 5.845s2.365 5.345 5.285 5.345c1.315 0 2.515-.49 3.44-1.29l2.42 2.455a.496.496 0 0 0 .705.005.5.5 0 0 0 0-.71zm-6.57-1.465c-2.36 0-4.28-1.945-4.28-4.34s1.92-4.34 4.28-4.34 4.28 1.945 4.28 4.34-1.92 4.34-4.28 4.34"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "ic-search_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 .5h12v12H0z"
})))));
export default SvgIcSearch;